<template>
    <v-expansion-panel class="expansion">
        <v-expansion-panel-header>
            <div class="col-12 expansionHeaderText">
                <h6>Add blocks in bulk with a template:</h6>
            </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <div class="row">
                <b-form-group label="flow template" label-for="className"
                              class="col-6 colLowPadding">
                    <b-form-select id="className" v-model="selectedFlowTemplate"
                                   :options="flowTemplatesOptions"/>
                </b-form-group>
                <v-spacer/>
                <v-divider vertical/>
                <v-spacer/>
                <div class="mx-auto text-center mt-5 col-5">
                    <v-spacer/>
                    <v-btn @click="addBlocksFromTemplate()" :style="primaryStyle" block>
                        Apply template
                    </v-btn>
                    <v-spacer/>
                </div>
            </div>
            <div>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-left">Class</th>
                            <th class="text-left">Method</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="block in selectedFlowTemplate">
                            <td>
                                <span>{{block.className}}</span>
                            </td>
                            <td>
                                <span>{{block.methodName}}</span>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>

    import BlockRepository from '../../../../repositories/block.repository';

    export default {
        props: {
            currentBlocks: {
                type: Array,
                default: []
            },
            nextBlockIdProp: {
                type: Number,
                default: Number(process.env.VUE_APP_BLOCKEDITOR_MAX_BLOCKS + 1)
            }
        },
        data() {
            return {
                nextBlockId: this.nextBlockIdProp,
                maxBlocks: Number(process.env.VUE_APP_BLOCKEDITOR_MAX_BLOCKS),
                flowTemplates: [],
                selectedFlowTemplate: [],
            }
        },
        methods: {
            loadAllFlowTemplates() {
                BlockRepository.getAllFlowTemplates().then(res => {
                    if (res.data.success) {
                        this.flowTemplates = res.data.templates;
                        this.flowTemplatesOptions;
                    }
                });
            },
            addBlocksFromTemplate() {
                if (this.currentBlocks.length < this.maxBlocks) {
                    let self = this;
                    this.selectedFlowTemplate.forEach(function (block) {
                        let newBlock = {};
                        newBlock.id = self.nextBlockId;
                        newBlock.blockType = "BackendBlock";
                        newBlock.className = block.className;
                        newBlock.methodName = block.methodName !== undefined ? block.methodName : null;
                        self.currentBlocks.push(newBlock);
                        self.nextBlockId++;
                    });
                    this.$emit('next-block-id', this.nextBlockId);
                }
            }
        },
        created() {
            this.loadAllFlowTemplates();
        },
        computed: {
            flowTemplatesOptions() {
                let self = this;
                return Object.keys(this.flowTemplates).map(function (templateName) {
                    return {
                        value: self.flowTemplates[templateName],
                        text: templateName,
                    }
                });
            },
        },
        watch: {
            nextBlockIdProp(val) {
                this.nextBlockId = val;
            }
        }
    }
</script>
